export const getDefaultHeaders = () => {
  const authToken = localStorage.getItem("auth_token");
  return {
    Accept: "application/json",
    "Content-Type": "application/json; charset=UTF-8",
    "Access-Control-Allow-Origin": process.env.REACT_APP_CMS_URL,
    "Access-Control-Max-Age": 3600,
    "Access-Control-Allow-Headers":
      "Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With",
    "X-Frame-Options": "deny",
    "X-Content-Type-Options": "nosniff",
    "X-XSS-Protection": "1; mode=block",
    "X-RateLimit-Limit": "50",
    "Strict-Transport-Security": "max-age=31536000; includeSubDomains; preload",
    "Content-Security-Policy": 'frame-ancestors "none"',
    "Access-Control-Allow-Methods": "GET, POST, PUT",
    "Cache-Control": "no-cache", // Prevent browser caching
    Pragma: "no-cache",
    Expires: "0",
    ...(authToken && { Authorization: `Bearer ${authToken}` }),
  };
};
